import { styled, Box, Typography } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const { DARK_CONTAINER_FIELDS_ON_CARD, LIGHT_CONTAINER_FIELDS_ON_CARD, PLAIN_TEXT } = COLORS;

export const AudioItemCont = styled('div')(({ theme }) => ({
  display: 'flex',
  width: 200,
  borderRadius: 8,
  background: theme.palette.type === 'dark' ? DARK_CONTAINER_FIELDS_ON_CARD : LIGHT_CONTAINER_FIELDS_ON_CARD,
  alignItems: 'center',
  padding: '0 15px',
  height: 54,
  cursor: 'pointer',
  position: 'relative',
  [theme.breakpoints.down(960)]: {
    width: 'unset',
  },
}));

export const AudioInfo = styled(Box)(() => ({
  marginLeft: 15,
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
}));

export const AudioName = styled(Typography)(({ theme }) => ({
  fontSize: 14,
  fontWeight: 500,
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  width: 242,
  overflow: 'hidden',
  [theme.breakpoints.down(960)]: {
    width: 180,
    marginRight: 20,
  },
}));

export const Duration = styled(Box)(() => ({
  fontSize: 14,
  fontWeight: 500,
  color: PLAIN_TEXT,
}));

export const MainCont = styled(Box)(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-around',
  height: '100%',
  alignContent: 'flex-start',
}));
